import React from 'react';
import { ImageLightBoxStore } from '../../_flux/stores/image_light_box_store';
import { ImageLightBox } from '../../_flux/components/image_light_box/image_light_box';
import { expandAction, hideAction } from '../../_flux/actions/image_light_box_actions';
import LightboxStore from '../../_flux/stores/lightbox_store';
import { handleView } from '../handle_view';

const stores = {
    imageLightBox: ImageLightBoxStore,
    lightBox: LightboxStore,
};

function render(
    {
        imageLightBox,
        lightBox,
    },
) {
    const { visible, expanded } = imageLightBox;
    const LightBoxVisible = lightBox.visible;

    return (
        <ImageLightBox
            visible={visible}
            expanded={expanded}
            LightBoxVisible={LightBoxVisible}
            data={imageLightBox.obj}
            error={{ ...imageLightBox }}
            onExpand={() => {}}
            onClose={onClose}
        />
    );
}

const getOptions = options => ({
    ...options,
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);

export const onClose = () => {
    hideAction();
};